module.exports = __webpack_public_path__ + "static/img/wing_800.c90e1c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_800.jpg
// module id = qOGW
// module chunks = 0